export default __webpack_public_path__ + "static/media/stablecoin-logo.dacb0112.png";